import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs';

import { AuthService } from './auth-service';
import { EventService } from '../internal/event-service';
import { UserDashboard } from '@spotter/models/user-dashboard';
import { Profile } from '@spotter/models/profile';




@Injectable({ providedIn: 'root' })
export class UserService {

    // User data
    users: Array<Profile> = [];


    constructor(public http: HttpClient, public router: Router, public events: EventService, public auth: AuthService) {

        // Load the users into the array if we're a logged in admin
     /*   this.auth.isAdmin().then((isAdmin) => {
            if (isAdmin)
                this.getUsers().subscribe();
        }); */
    }



    /** Gets an array of all the users
     * 	You must be admin to do this
     */
    public getUsers(): Observable<Array<Profile>> {
        return new Observable(observer => {
            this.http.get<Array<Profile>>("/api/user")
                .subscribe({
                    next: (users) => {
                        this.users = users;
                        observer.next(users);
                        observer.complete();
                    },
                    error: (error) => {
                        console.error(error);
                        observer.error("Couldn't get the users");
                        observer.complete();
                    }
                });
        });

    }

    /** Updates a user's profile
     *  @param  profile      A complete user profile
    */
    public updateProfile(profile: Profile): Observable<Profile> {
        return new Observable(observer => {
            this.http.post<Profile>("/api/user/update-profile/" + profile.username, profile)
                .subscribe({
                    next: (profile) => {

                        // Find and update if we have the list stored
                        var foundIndex = this.users.findIndex(x => x.username == profile.username);
                        if (foundIndex >= 0)
                            this.users[foundIndex] = profile;

                        this.events.profileChanged.emit(profile);
                        observer.next(profile);
                        observer.complete();

                    },
                    error: (error) => {
                        console.error(error);
                        observer.error(error);
                        observer.complete();
                    }
                });
        });
    }


    /** Updates a user's avatar
         *  @param  avatar      A base 64 encoded avatar image
         *  @param  username    The username of the user
        */
    public updateAvatar(username: string, avatar: string): Observable<Profile> {
        return new Observable(observer => {
            this.http.post<Profile>("/api/user/update-avatar/" + username, { avatar: avatar })
                .subscribe({
                    next: (profile) => {
                         // Find and update if we have the list stored
                         var foundIndex = this.users.findIndex(x => x.username == profile.username);
                         if (foundIndex >= 0)
                             this.users[foundIndex] = profile;

                        this.events.profileChanged.emit(profile);
                        observer.next(profile);
                        observer.complete();
                    },
                    error: (error) => {
                        console.error(error);
                        observer.error(error);
                        observer.complete();
                    }
                });
        });
    }


    public getDashboard() : Promise<UserDashboard>
    {
        return new Promise<UserDashboard>((resolve, reject) => {
            this.http.get<UserDashboard>("/api/profile/dashboard")
            .subscribe({
                next: (data) => {
                    console.log(data);
                    resolve(data);
                },
                error: (error) => {
                    console.error(error);
                    reject();
                }
            });
        });
    }

}
